import { http } from '@/app/lib/http/client'

export interface PaymentMethodItem {
  id: number
  company_id: number
  name: string
  code: string
  is_active: boolean
  sort_order: number
  requires_reference: boolean
  allows_change: boolean
  created_at?: string
  updated_at?: string
}

export interface CreatePaymentMethodPayload {
  name: string
  code: string
  is_active?: boolean
  sort_order?: number
  requires_reference?: boolean
  allows_change?: boolean
}

export interface UpdatePaymentMethodPayload {
  name?: string
  is_active?: boolean
  sort_order?: number
  requires_reference?: boolean
  allows_change?: boolean
}

export const paymentMethodService = {
  // Obtener todos
  async getItems(params?: { per_page?: number; search?: string; page?: number; all?: boolean; is_active?: boolean }) {
    const response = await http.get('/payment-methods', { params })
    return response.data
  },

  async getItem(id: number) {
    const response = await http.get(`/payment-methods/${id}`)
    return response.data
  },

  // Crear
  async createItem(payload: CreatePaymentMethodPayload) {
    const response = await http.post('/payment-methods', payload)
    return response.data
  },

  // Actualizar
  async updateItem(id: number, payload: UpdatePaymentMethodPayload) {
    const response = await http.put(`/payment-methods/${id}`, payload)
    return response.data
  },

  // Cambiar estado activo/inactivo (PATCH)
  async toggleStatus(id: number) {
    const response = await http.patch(`/payment-methods/${id}/status`)
    return response.data
  },
}
